export default __webpack_public_path__ + "static/media/cake-icon.61bbf885.svg";